const StatsSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-5xl font-black text-gray-900 mb-6 leading-tight">
              実績と信頼
            </h2>
            <p className="text-gray-600 leading-relaxed mb-8 text-base">
              本プロジェクトは、地域の医療機関と連携し、心不全患者様の早期発見と適切な管理を実現してきました。継続的なモニタリングと包括的なケアにより、多くの患者様の生活の質の向上に貢献しています。医療従事者の皆様と共に、心不全医療の未来を創造します。
            </p>
            <div className="mb-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4">2024年 検査実施データ（予定）</h3>
              <div className="space-y-4">
                <div className="flex items-center justify-between border-b border-gray-200 pb-3">
                  <span className="text-gray-700 text-sm">経皮的冠動脈形成術</span>
                  <span className="text-3xl font-black text-primary-500">284件</span>
                </div>
                <div className="flex items-center justify-between border-b border-gray-200 pb-3">
                  <span className="text-gray-700 text-sm">末梢血管カテーテル治療</span>
                  <span className="text-3xl font-black text-primary-500">92件</span>
                </div>
                <div className="flex items-center justify-between border-b border-gray-200 pb-3">
                  <span className="text-gray-700 text-sm">心臓胸部大動脈手術</span>
                  <span className="text-3xl font-black text-primary-500">288件</span>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative z-10">
              <div className="absolute top-0 left-0 w-64 h-64 rounded-3xl overflow-hidden shadow-xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/4e5ee84e9483754cdd252158a2c81169.jpg"
                  alt="Medical Equipment"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute bottom-0 right-0 w-80 h-96 rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=compassionate%20doctor%20consulting%20with%20elderly%20patient%20in%20bright%20modern%20clinic%2C%20warm%20professional%20interaction%20showing%20trust%20and%20care%2C%20medical%20professional%20explaining%20heart%20health%20with%20gentle%20reassuring%20manner%2C%20clean%20contemporary%20healthcare%20setting%20with%20natural%20lighting&width=500&height=600&seq=stats-img-002&orientation=portrait"
                  alt="Doctor and Patient"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
